export const hasCssLength = (value: unknown): value is string =>
  typeof value === "string" && /^\d*\.?\d+(?:px|rem|em|%)$/.test(value);
